import { getSyncIcon, getSyncStatusID } from "../../../utils/Icons";
import { getUsLocaleString, getSyncLabel } from "../../../utils/TimeUtils";

import "../cellUnit.css";
export type LastSyncTimeProps = {
  value?: Date;
};

const LastSyncTimeCell: React.FC<LastSyncTimeProps> = ({ value }) => {
  return (
    <div className="cell-unit">
      <div className="overlay"></div>
      <img alt="icon" src={getSyncIcon(getSyncStatusID(value))}></img>
      <span className="body-medium">{getSyncLabel(value)}</span>
    </div>
  );
};

export default LastSyncTimeCell;
